export const ASSIGNMENT_SORTING_TYPES = {
    NEW_TO_OLD: {
        value: 'last_modified_desc',
        label: 'Activity: Recent to Old',
    },
    OLD_TO_NEW: {
        value: 'last_modified_asc',
        label: 'Activity: Oldest to Recent',
    },
    A_Z: {
        value: 'name_asc',
        label: 'Name: A-Z',
    },
    Z_A: {
        value: 'name_desc',
        label: 'Name: Z-A',
    },
}

export const DEFAULT_ASSIGNMENT_SORTING_TYPE = ASSIGNMENT_SORTING_TYPES.NEW_TO_OLD.value

export const CATALOG_SORTING_TYPES = {
    A_Z: {
        value: 'name_asc',
        label: 'Name: A-Z',
    },
    Z_A: {
        value: 'name_desc',
        label: 'Name: Z-A',
    },
}

export const DEFAULT_CATALOG_SORTING_TYPE = CATALOG_SORTING_TYPES.A_Z.value

export const CLUSTER_SORTING_TYPES = {
    A_Z: {
        value: 'name_asc',
        label: 'Name: A-Z',
    },
    Z_A: {
        value: 'name_desc',
        label: 'Name: Z-A',
    },
    SMALL_TO_LARGE: {
        value: 'size_asc',
        label: 'Size: Small to Large',
    },
    LARGE_TO_SMALL: {
        value: 'size_desc',
        label: 'Size: Large to Small',
    },
    GRADE_ASC: {
        value: 'grade_asc',
        label: 'Grade: Low to High',
    },
    GRADE_DESC: {
        value: 'grade_desc',
        label: 'Grade: High to Low',
    },
}

export const TextSubmissionGroupsSortingTypes = {
    A_Z: {
        value: 'name_asc',
        label: 'Name: A-Z',
    },
    Z_A: {
        value: 'name_desc',
        label: 'Name: Z-A',
    },
    SMALL_TO_LARGE: {
        value: 'size_asc',
        label: 'Size: Small to Large',
    },
    LARGE_TO_SMALL: {
        value: 'size_desc',
        label: 'Size: Large to Small',
    },
}

export const DEFAULT_TEXT_SUBMISSION_GROUPS_SORTING_TYPE = TextSubmissionGroupsSortingTypes.LARGE_TO_SMALL.value

export const DEFAULT_CLUSTER_SORTING_TYPE = CLUSTER_SORTING_TYPES.LARGE_TO_SMALL.value
